<template>
    <el-dialog v-dialogDrag title="组件库" :visible.sync="dialogVisible" width="80%" :modal="true"
        :modal-append-to-body="false" :appen-to-body="true" class="bs-dialog-wrap bs-el-dialog" @closed="close">
        <div class="content">
            <div class="big-screen-list-wrap">
                <div class="top-search-wrap">
                    <el-input v-model="searchKey" class="bs-el-input bs-el-input-search" placeholder="请输入页面名称"
                        prefix-icon="el-icon-search" clearable @clear="reSearch" @keyup.enter.native="reSearch" />
                    <el-button type="primary" size="mini" @click="reSearch">
                        搜索
                    </el-button>
                </div>
                <div v-loading="loading" class="list-wrap bs-scrollbar" element-loading-text="加载中" :style="{
                    display: gridComputed ? 'grid' : 'inline-flex',
                    justifyContent: gridComputed ? 'space-around' : 'flex-start'
                }">
                    <!-- 后面遍历 list  gridComputed ? 'auto' : '220px' -->
                    <div v-for="screen in list" :key="screen.id" class="big-screen-card-wrap" :style="{
                        width: gridComputed ? 'auto' : '220px'
                    }" @click="chooseComponent(screen)">
                        <div :class="focus.id == screen.id ? 'focus' : ''" class="big-screen-card-inner">
                            <div class="big-screen-card-img">
                                <div class="big-screen-type">
                                    {{ screen.type }}
                                </div>
                                <el-image :src="getCoverPicture(screen.cover_picture)" fit="fill"
                                    style="height: 100%;width: 100%;">
                                    <div slot="placeholder" class="image-slot">
                                        加载中···
                                    </div>
                                    <div slot="error" class="image-slot" style="font-size: 20px">
                                        <div class="error-img-text">
                                            {{ screen.name }}
                                        </div>
                                    </div>
                                </el-image>
                            </div>
                            <div class="big-screen-bottom">
                                <div class="left-bigscreen-title" :title="screen.name">
                                    {{ screen.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="bs-el-button-default" @click="dialogVisible = false">
                取消
            </el-button>
            <el-button type="primary" @click="confirm">
                确定
            </el-button>
            <el-button type="primary" @click="jumpto">
                组件管理
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as echarts from 'echarts'
import { displayOption } from '@/components/data-room-ui/packages/js/config'
import { pageMixins } from '@/components/data-room-ui/packages/js/mixins/page'
// import _ from 'lodash'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import innerRemoteComponents, { getRemoteComponents, getRemoteComponentConfig } from '@/components/data-room-ui/packages/RemoteComponents/remoteComponentsList'

export default {
    name: 'ComponentDialog',
    mixins: [pageMixins],
    props: {},
    data() {
        return {
            typeDesc: {
                bigScreen: '大屏',
            },
            dialogVisible: false,
            loading: false,
            options: [], // 分组列表
            code: '',
            focus: -1,
            list: [],
            searchKey: '',
            name: '', // 业务组件搜索关键字
            activeName: 'combination',

            // 业务组件列表
            bizComponentList: [],
            bizComponenTotalCount: 0
        }
    },
    computed: {
        gridComputed() {
            return this.list.length > 3
        },
    },
    watch: {
        activeName() {
            this.current = 1
            this.size = 10
            this.getDataList()
        }
    },
    mounted() {
    },
    methods: {
        jumpto() {
            const { href } = this.$router.resolve('/index/page-list?type=component')
            window.open(href, '_blank')
        },
        chooseComponent(component) {
            this.focus = cloneDeep(component)
        },
        close() { },
        init() {
            this.dialogVisible = true
            this.current = 1
            this.searchKey = ''
            this.code = ''
            this.focus = -1
            this.getDataList()
        },
        // 点击确定
        confirm() {
            this.dialogVisible = false
            if (Object.keys(this.focus).length) {
                this.$emit('setComponent', this.focus)
            }
        },
        getDataList() {
            this.loading = true
            this.$dataRoomAxios.post('/api/manage/bigScreen/page/list', {
                data: {
                    enterprise: localStorage.getItem('enterprise_id'),
                    page: this.current,
                    limit: this.size,
                    type: '3',
                    name: this.searchKey
                }
            })
                .then((data) => {
                    this.loading = false
                    this.list = data.data
                    this.totalCount = data.total
                })
                .catch(() => {
                    this.loading = false
                })
        },
        getCoverPicture(url) {
            if (url) {
                if (url.includes('data:image/')) {
                    // 如果是Base64格式，则直接返回URL
                    return url
                } else {
                    // 如果不是Base64格式，则调用getFileUrl方法获取文件URL
                    return '/api/common/files' + url
                }
            }
            return "";
        },
        /**
         * 处理当前组件的字符串配置
         */
        resolveStrSetting(settingContent) {
            // eslint-disable-next-line prefer-const
            let option = {}
            // eslint-disable-next-line prefer-const
            let setting = []
            // eslint-disable-next-line prefer-const, no-unused-vars
            let title = []
            // eslint-disable-next-line prefer-const, no-unused-vars
            let data = []
            // eslint-disable-next-line prefer-const, no-unused-vars
            let optionHandler = ''
            // eslint-disable-next-line prefer-const
            settingContent = settingContent.replaceAll('const ', '')
            // 去掉 export default及后面代码
            settingContent = settingContent.replace(/export default[\s\S]*/, '')
            eval(settingContent)
            option = {
                data,
                displayOption,
                ...option
            }
            return {
                option,
                setting,
                optionHandler
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: calc(100vh - 290px);
}

.big-screen-list-wrap {
    .el-select {
        display: inline-block !important;
        position: relative !important;
        width: auto !important;
    }

    position: relative;
    height: 100%;
    // margin:0 16px;
    // padding: 16px;
    margin-bottom: 56px;
    color: #9ea9b2;

    .top-search-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 12px;

        .el-input {
            width: 200px;
            margin-right: 20px;

            ::v-deep .el-input__inner {
                background-color: #151a26 !important;
            }
        }

        .el-select {
            margin-right: 20px;

            ::v-deep .el-input__inner {
                background-color: #151a26 !important;
            }
        }
    }

    .list-wrap {
        /* display: grid; */
        overflow: auto;
        // 间隙自适应
        justify-content: space-around;
        // max-height: calc(100vh - 270px);
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        grid-gap: 15px;

        .big-screen-card-wrap {
            position: relative;
            height: 230px;
            cursor: pointer;

            &:hover {
                .screen-card__hover {
                    height: 180px;
                }
            }

            .screen-card__hover {
                position: absolute;
                z-index: 999;
                top: 0;
                right: 0;
                left: 0;
                display: flex;
                overflow: hidden;
                align-items: center;
                justify-content: center;
                height: 0;
                transition: height 0.4s;
                background: #00000099;
            }

            .focus {
                color: var(--bs-el-text) !important;
                border: 1px solid#409EFF !important;
            }

            .big-screen-card-inner {
                overflow: hidden;
                width: 100%;
                height: 100%;
                cursor: pointer;
                // background-color: #232832;
                box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                // color: #ffffff;
                // border: 1px solid#151a26;

                &:hover {
                    color: var(--bs-el-text);
                    border: 1px solid#409EFF;
                }

                .add-big-screen-card-text {
                    color: #409EFF;
                    font-size: 24px;
                }

                .big-screen-card-img {
                    width: 100%;
                    height: 180px;

                    .big-screen-type {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 60px;
                        height: 30px;
                        background-color: #007aff;
                        color: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        z-index: 1;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    ::v-deep .image-slot {
                        height: 100%;
                        // background-color: #232832;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    ::v-deep .el-image__error {
                        // background-color: #1d1d1d;
                    }
                }

                .big-screen-bottom {
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    justify-content: space-between;
                    box-sizing: border-box;
                    width: 100%;
                    /*height: 26px;*/
                    padding: 0 10px;
                    height: calc(100% - 180px);
                    // color: #ffffff;

                    .left-bigscreen-title {
                        font-size: 14px;
                        overflow: hidden;
                        width: 100%;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .right-bigscreen-time-title {
                        font-size: 14px;
                        overflow: hidden;
                        width: 140px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }

                .big-screen-card-text {
                    font-size: 14px;
                    padding: 10px;
                    text-align: center;
                    color: #333;
                }
            }

            .big-screen-card-inner-add {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .el-loading-parent--relative {
        position: unset !important;
    }

    .footer-pagination-wrap {
        margin-top: 16px;
        position: absolute;
        width: 100%;
    }
}

.bs-pagination {
    ::v-deep .el-input__inner {
        width: 110px !important;
        border: none;
        // background: #151A26;
    }
}

.empty {
    width: 100%;
    height: 70%;
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .el-tabs__item {
    color: var(--bs-el-text);
}

.error-img-text {
    overflow: hidden;
    padding: 0 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}

::v-deep .el-tabs__nav-wrap {
    &:after {
        display: none;
    }
}

.empty {
    height: calc(100vh - 430px);
}
</style>
